import React, { useCallback, useImperativeHandle, useRef } from 'react';
import { FieldError } from 'react-hook-form';
import MaskedInput from 'react-text-mask';
import styled from 'styled-components';

import { ErrorMessage } from 'playup-web-core';
interface PhoneNumberInputProps {
	value: string;
	formError: FieldError | undefined;
	isSmallScreen: boolean;
	onChange: (value: string) => void;
	onBlur: () => void;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = React.forwardRef(
	({ value, formError, isSmallScreen = false, onChange, onBlur }, ref) => {
		const handleOnChange = useCallback(
			(e: React.ChangeEvent<HTMLInputElement>) => {
				onChange(e.target.value.split(' ').join(''));
			},
			[onChange]
		);
		const inputRef = useRef<HTMLInputElement>(null);
		useImperativeHandle(ref, () => ({
			focus: () => {
				if (inputRef?.current?.focus) {
					inputRef.current!.focus();
				}
			},
		}));
		return (
			<PhoneNumberInputContainer isSmallScreen={isSmallScreen}>
				Mobile Number
				<InputGroup isSmallScreen={isSmallScreen} isError={typeof formError !== 'undefined'}>
					<StyledMaskedInput
						value={value}
						render={(textMaskRef, props) => (
							<input
								{...props}
								ref={(node) => {
									textMaskRef(node);
									if (inputRef.current) {
										//@ts-ignore
										inputRef.current = node;
									}
								}}
							/>
						)}
						type={'tel'}
						//maxima of country code is 4, and phone number is 11
						mask={Array(15).fill(/[0-9]/)}
						className="form-control"
						placeholder="Enter your mobile number"
						guide={false}
						id="my-input-id"
						onBlur={onBlur}
						onChange={handleOnChange}
						$isSmallScreen={isSmallScreen}
					/>
				</InputGroup>
				{formError && <ErrorMessage textAlign="left">{formError.message}</ErrorMessage>}
			</PhoneNumberInputContainer>
		);
	}
);
const PhoneNumberInputContainer = styled.div<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	display: 'flex',
	flexDirection: 'column',
	marginBottom: '20px',
	color: theme.colors.darkR,
	fontSize: isSmallScreen ? '14px' : '16px',
}));

const StyledMaskedInput = styled(MaskedInput)(({ $isSmallScreen }) => ({
	padding: 10,
	fontSize: $isSmallScreen ? '14px' : '18px',
	width: '100%',
	color: '#2d3134',
	'::placeholder': {
		color: '#a4a6a8',
	},
	minHeight: $isSmallScreen ? 40 : 50,
}));

const InputGroup = styled.div<{ isSmallScreen: boolean; isError: boolean }>(({ theme, isSmallScreen, isError }) => ({
	flexDirection: 'row',
	border: `2px solid ${isError ? theme.colors.danger : '#dde1e3'}`,
	borderRadius: '4px',
	marginTop: isSmallScreen ? '5px' : '7px',
}));
export default PhoneNumberInput;
